import { makeAutoObservable, runInAction } from "mobx";
import { store, type RootStore } from "@/store";

export class WidgetPositioner {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this);
  }

  get subtitlesBottomOffset() {
    if (store.pyneSettings.debug) {
      return 28;
    }

    return 16;
  }

  get promptBottomOffset() {
    if (store.pyneSettings.debug) {
      return 96;
    }

    return 84;
  }

  get additionalContentBottomOffset() {
    if (store.pyneSettings.debug) {
      return 206;
    }

    return 194;
  }

  get stylesheetContent() {
    const content = `
      #pyne-subtitles {
        bottom: ${this.subtitlesBottomOffset}px;
      }

      #pyne-prompt {
        bottom: ${this.promptBottomOffset}px;
      }

      #pyne-additional-content{
        bottom: ${this.additionalContentBottomOffset}px;
      }
    `;
    return content;
  }
}
